import React from 'react';
import ReactHtmlParser from 'react-html-parser';
import { useTranslation } from 'react-i18next';
import DOMPurify from 'dompurify';
import { v4 as uuidv4 } from 'uuid';

import Label from '../../../../components/shared/Label/Label';
import Section from '../../../../components/shared/Section/Section';
import VideoPlayer from '../../../../components/shared/VideoPlayer/VideoPlayer';

import styles from './About.module.scss';

const About = ({ company }) => {
  const { t } = useTranslation('common');
  const {
    overview: companyOverview,
    locations: companyLocations,
    organization_status: companyStatus,
    industry: companyIndustry,
    organization_size: companySize,
    tags: companyTags,
    video_link: videoLink,
  } = company;

  const CompanyTagNames = companyTags.map((tag) => tag.name);

  const sanitizedData = DOMPurify.sanitize(companyOverview);

  const companyAbout = (
    <div className={styles.descriptionSection}>
      <div className={styles.aboutSection}>{ReactHtmlParser(sanitizedData)}</div>
    </div>
  );

  const headquarter = companyLocations.find((location) => location.type_name === 'headquarter');

  const sections = [
    { heading: t('company.about'), content: companyAbout },
    { heading: t('company.industry'), content: companyIndustry?.name },
    { heading: t('company.companySize'), content: companySize?.name },
    { heading: t('company.status'), content: companyStatus?.name },
    { heading: t('company.headquarters'), content: headquarter?.full_address },
  ];

  return (
    <div className={styles.container}>
      <div className={styles.sectionContent}>
        {sections.map((section) => (
          <Section key={uuidv4()} heading={section.heading} content={section.content} />
        ))}
      </div>
      {companyTags && companyTags.length > 0 && (
        <div className={styles.containerHeading}>
          <div className={styles.heading}>{t('company.perksBenefits')}</div>
          <Label tags={CompanyTagNames} />
        </div>
      )}
      {videoLink && (
        <div className={styles.videoContainer}>
          <VideoPlayer url={videoLink} />
        </div>
      )}
    </div>
  );
};

export default About;
